import { createApi } from "@reduxjs/toolkit/query/react";
import { mapInvoiceToTable } from "@/redux/mappers/Export/CreateNewJob/InvoiceMapper/InvoiceMainMapper";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { useParams } from "react-router";

export const invoicemainApi = createApi({
  reducerPath: "invoicemainApi",
  baseQuery,
  tagTypes: ["Invoice"],
  endpoints: (builder) => ({
    getInvoiceByMasterId: builder.query({
      query: ({ id }) => {
        return `export/invoice/main/${id}`;
      },
      transformResponse: (response) => {
        const data = response?.data?.invoices ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item, idx) => ({
          ...item,
          id: item.exportInvoiceId,
          srNo: 1 + idx,
          totalProductValue: response?.data?.totalProductValue,
          totalInvoiceValue: response?.data?.totalInvoiceValue,
        }));
      },
      providesTags: ["Invoice"],
    }),

    // 🔹 Get single invoice by Id
    getInvoiceById: builder.query({
      query: ({ exporterMasterId, exportInvoiceId }) =>
        `export/invoice/main/${exporterMasterId}/${exportInvoiceId}`,
      transformResponse: (response) => response?.data ?? null,
      providesTags: ["Invoice"],
    }),

    getInvoiceMaster: builder.query({
      query: (id) => {
        const { exporterId } = useParams();
        return `export/invoice/main/${exporterId}`;
      },
      transformResponse: (response) => {
        const data = mapInvoiceToTable(response?.data?.invoices) ?? [];

        return data;
      },
      providesTags: ["Invoice"],
    }),

    //testing get Api
    getInvoiceMain: builder.query({
      query: (exporterMasterId) =>
        exporterMasterId
          ? `/export/invoice/main/${exporterMasterId}`
          : "/export/invoice/main",
      transformResponse: (response) =>
        mapInvoiceMainGet(response?.data?.invoices) ?? [],
      providesTags: ["Invoice"],
    }),

    // 🔹 Create new invoice
    createInvoice: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/invoice/main/${id}`,
        method: "PUT",
        body: { invoice: data },
      }),
      invalidatesTags: ["Invoice"],
    }),

    // 🔹 Update invoice by Id
    updateInvoice: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/invoice/main/${id}/${subId}`,
        method: "PUT", // should be PUT, not GET
        body: { invoice: data },
      }),
      invalidatesTags: ["Invoice"],
    }),

    // 🔹 Delete invoice by Id
    deleteInvoice: builder.mutation({
      query: ({ id }) => ({
        url: `export/invoice/main/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invoice"],
    }),
  }),
});

export const {
  useLazyGetInvoiceByMasterIdQuery,
  useCreateInvoiceMutation,
  useUpdateInvoiceMutation,
  useDeleteInvoiceMutation,
  useGetInvoiceMasterQuery,
  useGetInvoiceMainQuery,
} = invoicemainApi;
